var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDance(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "flat",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m280 256v24l-9.09 40-30.91 136-32 24h-24l24-40v-184z",
    fill: "#ffceb6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m280 256v24l-9.09 40h-62.91v-64z",
    fill: "#62798c"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m328 48-16 8 5.35986 10.72a8.19319 8.19319 0 0 1 -10.37986 11.27l-34.98-13.99a48.004 48.004 0 0 0 -48 48v40h-40v-48a80.00365 80.00365 0 0 1 80-80h64z",
    fill: "#ffceb6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m272 24v40a48.004 48.004 0 0 0 -48 48v40h-40v-48a80.00365 80.00365 0 0 1 80-80z",
    fill: "#4f7ff7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m216 136 16-24v-7.742a13.36168 13.36168 0 0 1 7.38615-11.951 13.3617 13.3617 0 0 1 15.42366 2.50292l25.19019 25.19008v48h-64z",
    fill: "#ffceb6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m232 192h47.20788a49.75838 49.75838 0 0 0 48.79212-40l-4.01684-1.00421a74.609 74.609 0 0 1 -43.98316-30.99579l-24 8-24 36z",
    fill: "#b1712c"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m408 80v56l-18.43018 110.58008a39.99919 39.99919 0 0 1 -39.45996 33.41992h-110.10986a63.96388 63.96388 0 0 1 -64-64 28.93908 28.93908 0 0 1 -16-25.89014v-14.10986a47.99956 47.99956 0 0 1 -48-48v-94.69995a9.29832 9.29832 0 0 1 18.12012-2.94019l5.87988 17.64014 10.33008-5.16992a8.79253 8.79253 0 0 1 12.46 10l-6.79008 27.16992v40a15.99564 15.99564 0 0 0 16 16h48a24.00619 24.00619 0 0 1 24 24v64h96l40-88-8-16z",
    fill: "#ffceb6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m240 160v64l-55.55 23.81006a63.678 63.678 0 0 1 -8.45-31.81006 28.93908 28.93908 0 0 1 -16-25.89014v-14.10986a47.99956 47.99956 0 0 1 -48-48v-48h40v40a15.99564 15.99564 0 0 0 16 16h48a24.00619 24.00619 0 0 1 24 24z",
    fill: "#548aff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m288 224v56h-48a64.02927 64.02927 0 0 1 -55.55-32.18994l55.55-23.81006z",
    fill: "#718799"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDance);
export default __webpack_public_path__ + "static/media/dance.98d2c692c1b5ef2d1775a028975a7c7c.svg";
export { ForwardRef as ReactComponent };